import * as React from "react"

const VisaCard = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" 
  {...props}
  >
    <path d="m19.662 11.156.375 1.716h-1.344l.645-1.661.215-.567.109.512zM24 5v14a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h20a2 2 0 0 1 2 2zM6.854 14.971l2.549-5.929H7.688l-1.585 4.051-.169-.823-.568-2.73c-.098-.377-.383-.489-.734-.502H2.021L2 9.161a6.849 6.849 0 0 1 1.701.651l1.44 5.16 1.713-.001zm4.823-5.934h-1.619l-1.012 5.941h1.619l1.012-5.941zm4.625 3.999c.006-.676-.425-1.19-1.359-1.614-.566-.275-.913-.458-.909-.736 0-.247.293-.511.927-.511.53-.008.913.107 1.212.228l.145.068.219-1.287a4.168 4.168 0 0 0-1.451-.25c-1.6 0-2.727.806-2.737 1.961-.009.854.805 1.33 1.419 1.614.63.291.842.477.839.737-.004.398-.503.58-.969.58-.648 0-.992-.09-1.524-.312l-.209-.095-.227 1.33c.378.166 1.078.31 1.804.317 1.702 0 2.807-.797 2.82-2.03zM22 14.98l-1.311-5.937h-1.251c-.388 0-.678.106-.848.493l-2.405 5.444h1.7l.341-.893 2.074.003.197.89H22z" />
  </svg>
)

export default VisaCard;
